import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'
// 读取的是login.js
import Login from './login.js'
// 读取的是移动端Examination .js
import MobileExamination from './mobileExamination.js'
// 读取的是移动端登录login.js
import MobileLogin from './mobileLogin.js'
//读取的是首页home.js
import Home from './home.js'
// 答题界面
import Answer from './answer.js'
// 无授权页面
import Noaccess from './noaccess'
// 编辑试题test
// import Professional from './professional.js'
import * as types from '@/vuex/types'
import store from '@/vuex/store'

//学生答题
import AnswerStudent from './student/answerstudent.js'

//学生答题信息
import ConfirmInformation from './studentMobile/confirmInformation.js'

//学生移动端答题
import AnswerStudentMobile from './studentMobile/answerstudent.js'
//查询某学生所在的班级已推送的练习库
import StudentMobileExamination from './studentMobile/examination.js'

//专业管理
import MajorPid from './admin/major.js'

import Authorize from './admin/authorize.js'

import http from '@/fetch/http'

import HomePage from './homePage.js'

import schoolManager from './admin/schoolManagement.js'
import personalManager from './admin/personalManagement.js'

import Test from './test.js'
Vue.use(Router)
const router = new Router({
  routes: [
    Test,
    Login,
    MobileLogin,
    Home,
    // 授课答题界面
    Answer,
    //学生答题
    AnswerStudent,
    //学生移动端答题
    AnswerStudentMobile,
    //查询某学生所在的班级已推送的练习库
    StudentMobileExamination,
    //无授权页面
    Noaccess,
    //移动端学生成绩排名
    MobileExamination,
    // 授权激活
    Authorize,
    //专业管理
    MajorPid,
      //后台管理首页
    HomePage,
    schoolManager,
    personalManager,
    ConfirmInformation,
  ],
  linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
  // session
  if (types.ANON_URL.indexOf(to.path) < 0) {
    let cookies = document.cookie.split(";");
    let sessionIdExist = false;
    for(let i in cookies){
      let cookieItems = cookies[i].split("=");
      if(cookieItems[0] && cookieItems[0].trim()=="ad.es.session.id"){
        if(cookieItems[1]){
          sessionIdExist = true;
        }
        break;
      }
    }
    let u = navigator.userAgent, app = navigator.appVersion;
    // 终端
    let browserInfo = {
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1 //是否iPad
    };
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    var href = window.location.href;
    var username = href.substring(href.indexOf("username")+9,href.indexOf("&autoLoginToken"));
    var autoLoginToken = href.substring(href.indexOf("autoLoginToken")+15,href.indexOf("&requestId="));
    var requestId = href.substring(href.indexOf("requestId")+10,href.indexOf("&examId="));
    var examId = href.substring(href.indexOf("examId")+7,href.length);
    if (store.state.user.loginStatus || sessionIdExist) {
      if(to.path == "/"){
        if(browserInfo.mobile || browserInfo.iPad || browserInfo.iPhone|| browserInfo.ios|| browserInfo.android){
          if(examId != null){
            next({path: '/studentMobile/home/confirmInformation', query: {examId: this.examId}});
          } else {
            next({path: '/studentMobile/examination'});
          }
        }else{
          next({path: '/login'});
        }
      }else{
        if(to.path.indexOf("studentMobile/home/confirmInformation")>0){
          // 没有考试则返回列表
          if(!to.query.examId){
            next({path: '/studentMobile/examination'});
          }
          // 考试信息
          http.selectExamInfo({examId: to.query.examId}).then(res => {
            if(res.msgCode == types.STATUS_OK){
              // 未开始则返回列表
              if(!res.data || res.data.beginTime > res.data.nowTime){
                next({path: '/studentMobile/examination'});
              }else{
                next();
              }
            }else{
              if(browserInfo.mobile || browserInfo.iPad || browserInfo.iPhone|| browserInfo.ios|| browserInfo.android){
                next({path: '/studentMobile/examination'});
              }else{
                next({path: '/login'});
              }
            }
          })
        }else{
          next();
        }
      }
    } else {
      if(browserInfo.mobile || browserInfo.iPad || browserInfo.iPhone|| browserInfo.ios|| browserInfo.android){
        if(to.path == "/studentMobile/home/confirmInformation"){
          store.state.prePath = JSON.stringify(to);
        }
        if(href.indexOf("username=") > 0 && username != ""){
          next({path: '/mobileLogin',
            query:{username:username,autoLoginToken:autoLoginToken,requestId:requestId,examId:examId}
          })
        }else if(to.path == "/test"){
          next();
        } else {
          next({path: '/mobileLogin'});
        }
      }else if(to.path == "/test"){
        next();
      } else{
        next({path: '/login'});
      }
    }
  } else {
    next();
  }
// }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js